import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import {
  getStatusInfoRead,
  IStatusInfoProps,
  setStatusInfoRead,
} from 'APIPackage/MainModule/services/statusInfoReadApi';
import { init } from 'KnmPackage/MainModule/common/cryptoHelpers';

import { CheckPluginStatusesEnum } from '../enums/CheckPluginStatusesEnum';
import { RootActions } from '../types/RootActions';
import { coreSetVisibleCheckPluginModal } from '../actions/coreActions';

export function useStatusInfoRead() {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const getStatus = useCallback(async () => {
    try {
      const res = await getStatusInfoRead();

      return res;
    } catch (e) {
      //
    }
  }, []);

  const setStatus = useCallback(async (data: IStatusInfoProps) => {
    try {
      await setStatusInfoRead(data);
    } catch (e) {
      //
    }
  }, []);

  const checkPlugin = useCallback(async () => {
    try {
      await init();
      setStatus({ status: CheckPluginStatusesEnum.AGREE });
    } catch (err) {
      dispatch(coreSetVisibleCheckPluginModal(true));
    }
  }, [dispatch, setStatus]);

  return { getStatus, setStatus, checkPlugin };
}
